export default __webpack_public_path__ + "static/media/Greek Environmental Energy Network.f616eed9.png";